import { RestClientService } from '../rest-client.service';
import { CloudDataService } from './cloud-data.service';
import { ObservableResult } from '../../models/result.model';
import {
  AdminMandant,
  Area, DeactivationTicket,
  Duplicate,
  Employee,
  EmployeeDetails, EmployeeUpdateDetails, K2HelpEmployeeTicketData,
  OrgUnitSetting, UserRightsDisableReasonModel
} from '../../models/cloud/cloud.model';
import { IHealthCheck } from '../../models/contacts/contacts.model';
import { Location } from '@angular/common';
import { environment } from '../../environments/environment';
import { catchError, switchMap } from 'rxjs/operators';

export class ApiCloudDataService implements CloudDataService {

  constructor(
    private client: RestClientService
  ) {
  }

  getAdminMandants(): ObservableResult<AdminMandant[]> {
    const url = '/api/Cloud/AdminMandants';
    const method = 'GET';

    return this.client.requestWithConstUrl<AdminMandant[]>(method, url);
  }

  getOrgUnitSettings(mandantId: number): ObservableResult<OrgUnitSetting[]> {
    const url = `/api/Settings/OrganizationalUnits/${mandantId}`;
    const method = 'GET';

    return this.client.requestWithConstUrl<OrgUnitSetting[]>(method, url);
  }

  saveOrgUnitSetting(setting: OrgUnitSetting): ObservableResult<void> {
    const url = '/api/Settings/OrganizationalUnit';
    const method = 'POST';

    return this.client.requestWithConstUrl<void>(method, url, setting);
  }

  deleteOrgUnitSetting(id: number): ObservableResult<void> {
    const url = `/api/Settings/OrganizationalUnit/${id}`;
    const method = 'DELETE';

    return this.client.requestWithConstUrl<void>(method, url);
  }

  getAreas(mandantId: number): ObservableResult<Area[]> {
    const url = `/api/Settings/Areas/${mandantId}`;
    const method = 'GET';

    return this.client.requestWithConstUrl<Area[]>(method, url);
  }

  saveArea(area: Area): ObservableResult<void> {
    const url = '/api/Settings/Area';
    const method = 'POST';

    return this.client.requestWithConstUrl<void>(method, url, area);
  }

  deleteArea(mandantId: number, num: number): ObservableResult<void> {
    const url = `/api/Settings/Area/${mandantId}/${num}`;
    const method = 'DELETE';

    return this.client.requestWithConstUrl<void>(method, url);
  }

  getEmployees(mandantId: number): ObservableResult<Employee[]> {
    const url = `/api/Cloud/Employees`;
    const method = 'GET';

    return this.client.requestWithConstUrl<Employee[]>(method, url, { mandantId });
  }

  updateEmployee(employee: EmployeeUpdateDetails, mandantId: number): ObservableResult<void> {
    const url = `/api/Settings/UpdateProfile/${mandantId}`;
    const method = 'POST';

    return this.client.requestWithConstUrl<void>(method, url, employee);
  }

  getEmployee(employeeId: number, mandantId: number): ObservableResult<EmployeeDetails> {
    const url = `/api/Settings/Profile/${mandantId}/${employeeId}`;
    const method = 'GET';

    return this.client.requestWithConstUrl<EmployeeDetails>(method, url);
  }

  getDuplicates(mandantId: number): ObservableResult<Duplicate[]> {
    const url = `/api/Settings/Duplicates/${mandantId}`;
    const method = 'GET';

    return this.client.requestWithConstUrl<Duplicate[]>(method, url);
  }

  getUserRightsDisableReasons(): ObservableResult<UserRightsDisableReasonModel[]> {
    const url = '/api/Cloud/CloudUserDisableReasons';
    const method = 'GET';

    return this.client.requestWithConstUrl<UserRightsDisableReasonModel[]>(method, url);
  }

  getK2HelpEmployeeData(): ObservableResult<K2HelpEmployeeTicketData[]> {
    const url = Location.joinWithSlash(environment.apiRootUrl || '', 'contacts/k2help/employees');
    return this.client.get<{ data: K2HelpEmployeeTicketData[] }>(url).pipe(
        switchMap(({body}) => ObservableResult.ofSuccess(body.data)),
        catchError(err => ObservableResult.ofError(err?.data, err?.status))
    );
  }

  submitDeactivationTicket(ticket: DeactivationTicket): ObservableResult<void> {
    const url = Location.joinWithSlash(environment.apiRootUrl || '', 'contacts/k2help/ticket');
    return this.client.post<{ data: void }>(url, ticket).pipe(
        switchMap(({body}) => ObservableResult.ofSuccess(body.data)),
        catchError(err => ObservableResult.ofError(err?.data, err?.status))
    );
  }

}
